import React from 'react';
import { HiOutlineMail, HiOutlineBookOpen, HiOutlinePhone } from 'react-icons/hi';

export default function Support() {
  const faqItems = [
    { q: '¿Cómo añado un nuevo socio?', a: 'Ve a Socios y pulsa "Crear Socio". Completa el formulario y guarda.' },
    { q: '¿Cómo cambio mi contraseña?', a: 'Entra en Perfil (menú inferior) y usa la sección "Seguridad".' },
    { q: '¿Dónde veo el historial de ventas?', a: 'En Panel de Control verás estadísticas y en Contabilidad el detalle de transacciones.' },
    { q: '¿Puedo usar ClubsAgent en el móvil?', a: 'Sí, tenemos app móvil para gestionar entradas y consultas en el dispensario.' },
  ];

  return (
    <div className="max-w-4xl mx-auto px-3 sm:px-4 py-2 sm:py-4 max-w-full">
      <h1 className="text-xl sm:text-2xl font-bold text-gray-900 mb-2">Ayuda y Soporte</h1>
      <p className="text-gray-600 mb-4 sm:mb-8 text-sm sm:text-base">Resuelve dudas y contacta con nosotros.</p>

      <section className="mb-10">
        <h2 className="flex items-center gap-2 text-lg font-semibold text-gray-900 mb-4">
          <HiOutlineBookOpen className="text-purple-600" />
          Preguntas frecuentes
        </h2>
        <ul className="space-y-3 sm:space-y-4">
          {faqItems.map((item, i) => (
            <li key={i} className="bg-white border border-gray-200 rounded-lg p-3 sm:p-4 shadow-sm">
              <p className="font-medium text-gray-900">{item.q}</p>
              <p className="text-gray-600 text-sm mt-1">{item.a}</p>
            </li>
          ))}
        </ul>
      </section>

      <section className="mb-10">
        <h2 className="flex items-center gap-2 text-lg font-semibold text-gray-900 mb-4">
          <HiOutlineMail className="text-purple-600" />
          Contactar soporte
        </h2>
        <div className="bg-white border border-gray-200 rounded-lg p-4 sm:p-6 shadow-sm">
          <p className="text-gray-600 mb-2 text-sm sm:text-base">Email: <a href="mailto:soporte@leafgate.eu" className="text-purple-600 hover:underline">soporte@leafgate.eu</a></p>
          <p className="text-gray-600 text-sm">Te responderemos en menos de 24 horas laborables.</p>
        </div>
      </section>

      <section>
        <h2 className="flex items-center gap-2 text-lg font-semibold text-gray-900 mb-4">
          <HiOutlinePhone className="text-purple-600" />
          Acerca de ClubsAgent
        </h2>
        <div className="bg-white border border-gray-200 rounded-lg p-4 sm:p-6 shadow-sm text-gray-600 text-sm">
          <p>ClubsAgent Beta 1.0.0 — Gestión de dispensarios y socios.</p>
          <p className="mt-2">© 2026 ClubsAgent. Todos los derechos reservados.</p>
        </div>
      </section>
    </div>
  );
}
